import { Button, Input } from "antd";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { AiOutlineSearch } from "react-icons/ai";

import { useThemeMode } from "sandbox/contexts/ThemeModeContext";

import s from "./SearchBar.module.css";

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  ariaLabel?: string;
}

export const SearchBar = ({
  value,
  onChange,
  placeholder,
  ariaLabel,
}: SearchBarProps) => {
  const { t } = useTranslation(["sandbox", "common"]);
  const { mode } = useThemeMode();
  const searchLabel = placeholder ?? t("common:labels.search");

  return (
    <section className={s.search}>
      <Input
        className={s.searchInput}
        placeholder={searchLabel}
        value={value}
        onChange={e => onChange(e.target.value)}
      />
      <Button
        className={clsx(s.searchButton, mode === "dark" && s.searchButtonDark)}
        aria-label={ariaLabel ?? searchLabel}
        icon={<AiOutlineSearch />}
      />
    </section>
  );
};
